import { render, staticRenderFns } from "./CustomerLogo.vue?vue&type=template&id=222d8e62&scoped=true"
import script from "./CustomerLogo.vue?vue&type=script&lang=js"
export * from "./CustomerLogo.vue?vue&type=script&lang=js"
import style0 from "./CustomerLogo.vue?vue&type=style&index=0&id=222d8e62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222d8e62",
  null
  
)

export default component.exports